import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 5a1 1 0 0 1 .905.574l8 17a1 1 0 0 1-1.81.852L21.013 19H10.988l-2.083 4.426a1 1 0 1 1-1.81-.852l2.328-4.946a1 1 0 0 1 .05-.105l5.622-11.949A1 1 0 0 1 16 5m0 3.349L20.072 17h-8.143z"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M3 27a1 1 0 1 0 0 2h26a1 1 0 1 0 0-2z" />
  </svg>
);
const SvgIconTextAUnderline = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconTextAUnderline);
export default Memo;
